/**
 * @fileoverview Zod schema for Goal entities (Supabase rows/DTOs).
 */

import { z } from 'zod';

export const GoalSchema = z
  .object({
    id: z.string(),
    user_id: z.string(),
    title: z.string().min(1),
    description: z.string().nullable().optional(),
    color_key: z.number().nullable().optional(),
    created_at: z.string().optional(),
    updated_at: z.string().optional(),
    importance_rank: z.number().int().nullable().optional(),
    // Progress tracking fields (added 2025-10-15)
    baseline_value: z.number().nullable().optional(),
    baseline_unit: z.string().nullable().optional(),
    target_value: z.number().nullable().optional(),
    target_unit: z.string().nullable().optional(),
    current_value: z.number().nullable().optional(),
    current_value_date: z.string().nullable().optional(),
  })
  .passthrough();

export type Goal = z.infer<typeof GoalSchema>;
export function parseGoal(input: unknown): Goal {
  return GoalSchema.parse(input);
}

export const GoalArraySchema = z.array(GoalSchema);
export type GoalArray = z.infer<typeof GoalArraySchema>;
